import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType(); // 🌟 Detects POP (Back button), PUSH (New link), or REPLACE

  useEffect(() => {
    // 1. If the user hits "Back" to go anywhere, let the browser restore their previous scroll position
    if (navType === 'POP') {
      return;
    }

    // 2. If navigating forward normally, but hitting the home page directly, leave scroll position alone
    if (pathname === '/') {
      return;
    }
    
    // For all other pages (Cart, Account, Product Detail, etc.) during a fresh click, snap to top
    window.scrollTo(0, 0);
  }, [pathname, navType]);

  return null;
}

export default ScrollToTop;